// store/persist/persist.ts
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

// Vytvořte instanci pinia
const pinia = createPinia();

// Registrujte plugin pro persistenci stavu
pinia.use(piniaPluginPersistedstate);

export default pinia;